module.exports = __webpack_public_path__ + "img/Logo_FondoBlanco_LetrasNegras.b12d9466.svg";